import { Action } from 'redux';

import { isSpaceContentsNextPageWithTokenSuccededAction,isSpaceContentsWithTokenRequestSucceededAction } from '~src/spacesPlatform/actions/RequestSpaceContentsActions';

export function contentMoreItemsForTokenRequestReducer(
  previousState: boolean = null,
  action: Action = null
): boolean {
  if ((isSpaceContentsWithTokenRequestSucceededAction(action) || isSpaceContentsNextPageWithTokenSuccededAction(action))
    && action?.contentWithToken) {
    return action.contentWithToken.moreItems;
  }

  return previousState;
}

